import { IFiltroEstadisticaMaquina } from '../models/IFiltroEstadisticaMaquina';
import { IMaquinaInforme } from '../models/IMaquinaInforme';
import { IReporteInforme } from '../models/IReporteInforme';
export const ReportesFeatureKey = 'currentMaquina';
export interface IMaquinaInformeState {
  form: IFiltroEstadisticaMaquina;
  informeMaquina: IMaquinaInforme;
  reportes: IReporteInforme
}

export const initialReporteState: IMaquinaInformeState = {
  form: null, // storage?.getItem("currentMaquina").form,
  informeMaquina: null, // storage?.getItem("currentMaquina").informeMaquina,
  reportes: null
  };
